import { call } from 'redux-saga/effects'

import actions from 'actions'
import api from 'services'
import { fetchData } from 'utils/sagas'
import { redirectAbsolutePath } from 'utils/redirect'
import { getSetupformUrl } from 'utils/urls'

export const signup = fetchData.bind(null, actions.signupRequest, api.signup)

export function* signupSubmitSaga({ data }) {
  yield call(signup, data)
}

export function* signupSubmitSuccessSaga({ response }) {
  redirectAbsolutePath(getSetupformUrl(response.partnerId))
}



/** WEBPACK FOOTER **
 ** ./src/sagas/signup/signup-sagas.js
 **/